"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDynamicCode = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var dynamicCode_1 = require("../../model/dynamicCode");
var service_1 = require("../../../library/base/service");
var GetDynamicCode = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetDynamicCode, _super);
    function GetDynamicCode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取短信验证码';
        _this.code = '300408';
        _this.desc = '获取短信验证码';
        _this.requestParams = new dynamicCode_1.GetDynamicCodeRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetDynamicCode;
}(service_1.BaseService));
exports.GetDynamicCode = GetDynamicCode;
//# sourceMappingURL=getDynamicCode.js.map